var exports = {
  "u": "chipsRow__EsSwnQ",
};

module.exports = exports;
